// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: '71616bd',
    builtAt: '2026-06-17T13:48:49.158Z',
} as const;
